import { MSG_CAMPO_OBRIGATORIO_GERAL, ALERTA, ENUM_TIPO_PESSOA } from 'utils/consts';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { fetchNotificationApp, fetchStatusModal } from 'store/fetchActions/fetchApp';
import { validationsCreate } from 'utils/validate/requerimento';
import { validarArquivosRequerimentoServico } from 'utils/validate/arquivo';
import { validarExibirErrosCampos } from 'utils/formUtils';
import { fetchSalvarInputsDadosCadastrais } from 'store/fetchActions/fetchInputForm';
import { fetchGetDadosCadastrais } from 'store/fetchActions/fetchDadosCadastrais';
import { formatterEnderecoBackToFrontRequerimento } from 'utils/formatter/endereco';
import { formatterDadosCadastraisBackToFrontRequerimento } from 'utils/formatter/dadosCadastrais';

export const isValidForSubmit = (dadosInputs, arquivos, setError) => dispatch => {
  const isValid = validarExibirErrosCampos(dadosInputs, validationsCreate, setError);

  if (!isValid) {
    dispatch(exibirNotificacaoErroCampo());
  } else if (!dispatch(validarArquivosRequerimentoServico(arquivos))) return false;
  return isValid;
};

export const exibirNotificacaoErroCampo = (descricaoMensagem = '') => dispatch => {
  dispatch(fetchStatusModal(false, ''));
  fetchNotificationApp(MSG_CAMPO_OBRIGATORIO_GERAL, descricaoMensagem, ALERTA.ERRO);
};

export const carregarDadosCadastrais = (user, setValue, getValues, inputDados) => dispatch => {
  if (user && user?.profile === ENUM_TIPO_PERFIL.CONTRIBUINTE) {
    dispatch(fetchGetDadosCadastrais()).then(pessoaApi => {
      const pessoaFisica = pessoaApi?.find(x => x.tipoPessoaId === ENUM_TIPO_PESSOA.fisica.id);
      const pessoaJuridica = pessoaApi?.find(x => x.tipoPessoaId === ENUM_TIPO_PESSOA.juridica.id);
      const endereco = pessoaJuridica?.endereco ?? pessoaFisica?.endereco;

      const pessoaFormatada = formatterDadosCadastraisBackToFrontRequerimento(
        pessoaFisica,
        pessoaJuridica,
        inputDados?.data,
        user
      );
      const enderecoFormatado = formatterEnderecoBackToFrontRequerimento(endereco);
      Object.keys(pessoaFormatada).forEach(key => {
        if (pessoaFormatada[key]) {
          setValue(key, pessoaFormatada[key]);
        }
      });
      Object.keys(enderecoFormatado).forEach(key => {
        if (enderecoFormatado[key]) {
          setValue(key, enderecoFormatado[key]);
        }
      });
      dispatch(fetchSalvarInputsDadosCadastrais({ ...pessoaFisica, ...pessoaJuridica, ...endereco }));
    });
  }
};
